import { Card } from "../shared";
import { ADDON_PLANS, ADDON_LIMIT } from "./constants";

// ── Team add-on card ───────────────────────────────────────────────────────
export function TeamAddonCard({ tier, isOwner, isPaid, teamAddon, teamMembers }) {
  const activeCount = teamMembers.filter(m => !m.status || m.status === "active").length;
  const limit       = ADDON_LIMIT[teamAddon] ?? 0;
  const addonLabel  = ADDON_PLANS.find(p => p.id === teamAddon)?.label;

  const handleCheckout = async (priceId) => {
    const { supabase: sb } = await import("../../supabaseClient");
    const { data: { session } } = await sb.auth.getSession();
    if (!session) { window.location.href = "/app?signin"; return; }
    const { data, error } = await sb.functions.invoke("create-checkout-session", { body: { priceId } });
    if (error || !data?.url) { alert("Could not start checkout. Please try again."); return; }
    window.location.href = data.url;
  };

  return (
    <Card style={{ marginBottom: 20 }}>
      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 16, marginBottom: 6 }}>
        👥 Team Members
      </div>
      <div style={{ fontSize: 12, color: "#9B9690", marginBottom: 16 }}>Add team members to collaborate on your portfolio.</div>

      {/* Free plan — locked */}
      {!isPaid && !isOwner && (
        <div style={{ background: "#F9F7F4", border: "1px solid #E8E4DC", borderRadius: 10, padding: "18px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: 13, color: "#2B2B2B", marginBottom: 4 }}>🔒 Team members require a Core or Pro plan</div>
            <div style={{ fontSize: 12, color: "#9B9690" }}>Upgrade your base plan first, then add a team add-on.</div>
          </div>
          <a href="/pricing#team" style={{ padding: "8px 18px", background: "#163C2F", color: "#F5F1EA", borderRadius: 999, textDecoration: "none", fontFamily: "'Manrope', sans-serif", fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" }}>
            Upgrade Plan
          </a>
        </div>
      )}

      {/* Owner — unlimited, no add-on needed */}
      {isOwner && (
        <div style={{ background: "#EAF2ED", border: "1px solid #C5DBC9", borderRadius: 10, padding: "14px 18px", fontSize: 13, color: "#163C2F", fontWeight: 600 }}>
          ✦ Owner plan includes unlimited team members.
        </div>
      )}

      {/* Core/Pro — show add-on options */}
      {isPaid && !isOwner && (
        <>
          {teamAddon !== "none" && (
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16, padding: "10px 14px", background: "#EAF2ED", border: "1px solid #C5DBC9", borderRadius: 8 }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: "#163C2F" }}>{addonLabel}</span>
              <span style={{ fontSize: 12, color: "#9B9690" }}>· {activeCount} of {limit === Infinity ? "∞" : limit} members used</span>
            </div>
          )}
          {teamAddon === "none" && (
            <div style={{ fontSize: 13, color: "#9B9690", marginBottom: 16 }}>No team add-on active. Choose a plan below.</div>
          )}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
            {ADDON_PLANS.map(plan => {
              const isCurrent = plan.id === teamAddon;
              return (
                <div key={plan.id} style={{ border: `1.5px solid ${isCurrent ? "#163C2F" : "#E8E4DC"}`, borderRadius: 10, padding: "16px 14px", background: isCurrent ? "#EAF2ED" : "#fff" }}>
                  <div style={{ fontWeight: 700, fontSize: 13, color: "#163C2F", marginBottom: 4 }}>{plan.label}</div>
                  <div style={{ fontSize: 19, fontWeight: 800, color: "#2B2B2B", fontFamily: "'Cormorant Garamond', serif", marginBottom: 4 }}>{plan.price}</div>
                  <div style={{ fontSize: 11, color: "#9B9690", marginBottom: 12 }}>Up to {plan.limit === Infinity ? "∞" : plan.limit} members</div>
                  {isCurrent
                    ? <div style={{ fontSize: 11, color: "#163C2F", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" }}>Current Plan</div>
                    : <button onClick={() => handleCheckout(plan.priceId)}
                        style={{ width: "100%", padding: "7px 0", background: "#163C2F", color: "#F5F1EA", border: "none", borderRadius: 999, fontFamily: "'Manrope', sans-serif", fontSize: 11, fontWeight: 700, cursor: "pointer", textTransform: "uppercase", letterSpacing: "0.06em" }}>
                        {teamAddon === "none" ? "Subscribe" : "Switch"}
                      </button>
                  }
                </div>
              );
            })}
          </div>
        </>
      )}
    </Card>
  );
}
